import { useState, useEffect } from 'react';

export const useCurrencyFieldAmor = (formik, fieldName) => {
  const rawValue = formik.values?.[fieldName.split('.')[0]]?.[fieldName.split('.')[1]] || '';
  const [displayValue, setDisplayValue] = useState(rawValue?.toString() || '');

  useEffect(() => {
    // Update displayValue if formik value changes externally
    if (rawValue !== displayValue) {
      setDisplayValue(rawValue?.toString());
    }
  }, [rawValue]);

  const formatCurrency = (value) => {
    const number = parseFloat(value);
    if (isNaN(number)) return '';
    return number.toLocaleString('en-US', {
      style: 'currency',
      currency: 'USD',
    });
  };

  const parseCurrency = (value) => {
    return value.replace(/[^0-9.]/g, '');
  };

  return {
    name: fieldName,
    value: displayValue,
    onChange: (e) => {
      const raw = parseCurrency(e.target.value);
      setDisplayValue(raw);
      formik.setFieldValue(fieldName, raw);
    },
    onBlur: (e) => {
      formik.handleBlur(e);
      const raw = parseCurrency(e.target.value);
      const formatted = formatCurrency(raw);
      setDisplayValue(formatted);
    },
    onFocus: () => {
      const raw = parseCurrency(displayValue);
      setDisplayValue(raw);
    },
  };
};
